import { c as _c } from "react/compiler-runtime";
import { useNextApiFetch } from '@newfront-insurance/next-api-swr';
import { routes } from '../bff/routes';
import type { CreateHistoricalPolicyBody, CreateHistoricalPolicyResponse, RenewPolicyAsIsBody, RenewPolicyAsIsResponse, UpdatePolicyBillingBody, UpdatePolicyBillingParams, UpdatePolicyBillingResponse, UpdatePolicyDateRangeBody, UpdatePolicyDateRangeParams, UpdatePolicyDateRangeResponse, UpdatePolicyDetailsBody, UpdatePolicyDetailsParams, UpdatePolicyDetailsResponse, UpdatePolicyLinesOfCoverageBody, UpdatePolicyLinesOfCoverageParams, UpdatePolicyLinesOfCoverageResponse, UpdatePolicyNotesBody, UpdatePolicyNotesParams, UpdatePolicyNotesResponse } from '../bff/types';
import { useCoverageApiBasePath } from '../provider';
interface PolicyApi {
  createHistoricalPolicy(body: CreateHistoricalPolicyBody): Promise<CreateHistoricalPolicyResponse | null>;
  updateNotes(params: UpdatePolicyNotesParams, body: UpdatePolicyNotesBody): Promise<UpdatePolicyNotesResponse | null>;
  updateBilling(params: UpdatePolicyBillingParams, body: UpdatePolicyBillingBody): Promise<UpdatePolicyBillingResponse | null>;
  updateDetails(params: UpdatePolicyDetailsParams, body: UpdatePolicyDetailsBody): Promise<UpdatePolicyDetailsResponse | null>;
  updateDateRange(params: UpdatePolicyDateRangeParams, body: UpdatePolicyDateRangeBody): Promise<UpdatePolicyDateRangeResponse | null>;
  updateLinesOfCoverage(params: UpdatePolicyLinesOfCoverageParams, body: UpdatePolicyLinesOfCoverageBody): Promise<UpdatePolicyLinesOfCoverageResponse | null>;
  renewAsIs(body: RenewPolicyAsIsBody): Promise<RenewPolicyAsIsResponse | null>;
}
export function usePolicyApi() {
  const $ = _c(3);
  const fetch = useNextApiFetch();
  const basePath = useCoverageApiBasePath();
  let t0;
  if ($[0] !== basePath || $[1] !== fetch) {
    t0 = {
      createHistoricalPolicy(body) {
        return fetch({
          url: withBasePath(basePath, routes.createHistoricalPolicy.getUrl({})),
          method: "POST",
          body
        });
      },
      updateNotes(params, body_0) {
        return fetch({
          url: withBasePath(basePath, routes.updatePolicyNotes.getUrl({
            policyUuid: params.policyUuid
          })),
          method: "PUT",
          body: body_0
        });
      },
      updateLinesOfCoverage(params_0, body_1) {
        return fetch({
          url: withBasePath(basePath, routes.updatePolicyLinesOfCoverage.getUrl({
            policyUuid: params_0.policyUuid
          })),
          method: "PUT",
          body: body_1
        });
      },
      updateBilling(params_1, body_2) {
        return fetch({
          method: "PUT",
          url: withBasePath(basePath, routes.updatePolicyBilling.getUrl({
            policyUuid: params_1.policyUuid
          })),
          body: body_2
        });
      },
      updateDetails(params_2, body_3) {
        return fetch({
          method: "PUT",
          url: withBasePath(basePath, routes.updatePolicyDetails.getUrl({
            policyUuid: params_2.policyUuid
          })),
          body: body_3
        });
      },
      updateDateRange(params_3, body_4) {
        return fetch({
          method: "PUT",
          url: withBasePath(basePath, routes.updatePolicyDateRange.getUrl({
            policyUuid: params_3.policyUuid
          })),
          body: body_4
        });
      },
      renewAsIs(body_5) {
        return fetch({
          method: "POST",
          url: withBasePath(basePath, routes.renewPolicyAsIs.getUrl({})),
          body: body_5
        });
      }
    };
    $[0] = basePath;
    $[1] = fetch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function withBasePath(basePath: string, url: string): string {
  return `${basePath}${url}`;
}